import * as actionTypes from "./actionTypes";

const licenseInitialState = {
  processing: false,
  loadingLicense: false,
  currentLicense: null,
  accounts: null,
  modules: null,
  countries: null,
};

export const adminLicenseReducer = (state = licenseInitialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.RESET_LICENSE:
      return licenseInitialState;
    case actionTypes.SET_PROCESSING:
      return { ...state, processing: true };
    case actionTypes.STOP_PROCESSING:
      return { ...state, processing: false };

    case actionTypes.GET_LICENSES:
      return {
        ...state,
        currentLicense: state.currentLicense
          ? { ...state.currentLicense, banks: [] }
          : payload.length
          ? { ...payload[0], banks: [] }
          : null,
        licenses: [...payload],
      };
    case actionTypes.SEARCH_LICENSES:
      return {
        ...state,
        licenses: [...payload],
      };
    case actionTypes.GET_BANKS:
      return {
        ...state,
        currentLicense: { ...state.currentLicense, banks: payload },
      };
    case actionTypes.UPDATE_LICENSE:
      return {
        ...state,
        processing: false,
        currentLicense: { ...payload, banks: [] },
      };
    case actionTypes.GENERATE_LICENSE:
      return {
        ...state,
        processing: false,
        currentLicense: { ...payload, banks: [] },
      };
    case actionTypes.SET_CURRENT_LICENSE:
      const selectedLicense = state.licenses.find(
        (license) => license.key === payload
      );
      return {
        ...state,
        currentLicense: { ...selectedLicense, banks: [] },
      };
    case actionTypes.GET_MODULES:
      return {
        ...state,
        modules: payload,
      };
    case actionTypes.GET_COUNTRIES:
      return {
        ...state,
        countries: payload,
      };
    case actionTypes.LOAD_LICENSE:
      return {
        ...state,
        loadingLicense: true,
      };
    case actionTypes.ADD_NEW:
      const license = {
        uniqueId: `${Date.now()}`,
        licenseName: "",
        bankId: "SELECT_BANK",
        bankName: "SELECT_BANK",
        bankShortName: "SELECT_BANK",
        bankBic: "SELECT_BANK_BIC",
        allowedUsers: 1,
        messages: "SELECT_MESSAGE_BAND",
        modules: [...state.modules].map((module) => ({
          ...module,
          isAllowed: module.isLocked ? true : false,
        })),
        key: `The key will be generated after saving`,
        expiryDate: new Date().toISOString(),
        formatedExpiryDate: null,
        creationDate: new Date().toISOString(),
        banks: [],
        isNew: true,
      };
      return {
        ...state,
        currentLicense: license,
        licenses: [...state.licenses, license],
      };
    case actionTypes.REMOVE_NEW:
      return {
        ...state,
        licenses: [...state.licenses].filter(
          (license) => license.isNew !== true
        ),
      };
    default:
      return state;
  }
};
